import Swiper from '@src/components/swiper';

document.addEventListener("DOMContentLoaded", function(event) {
  new Swiper('#section-connect-carousel .swiper-container', {
    initialSlide: 0,
    grabCursor: true,
    slidesPerView: 2.5,
    centeredSlides: true,
    spaceBetween: 100,
    simulateTouch: true,
    slideToClickedSlide: true,
    breakpoints: {
      1439: {
        slidesPerView: 2,
        spaceBetween: 50,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      1100: {
        slidesPerView: 1.6,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      950: {
        slidesPerView: 1.3,
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      },
      767: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
      }
    }
  });
});
